/**
 * @file: useConstructionJobResolveList.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { useTaskContext } from '@euler/app/flows/task/functions/TaskContext';
import { useFetchAsyncState } from '@euler/functions/useFetchAsyncState';
import { useServiceFactory } from '@euler/services/factory';
import { useEffect } from 'react';

export const useConstructionJobResolveList = () => {
  const { taskService } = useServiceFactory();
  const { taskNo } = useTaskContext();

  const [state, fetch] = useFetchAsyncState(
    () => {
      return taskService.fetchConstructionWorkItems(taskNo);
    },
    { status: 'loading' },
  );

  useEffect(() => {
    void fetch();
  }, [fetch]);

  return state;
};
